///jacques-andre-editeur\proshop-v2\frontend\src\screens\BooksCollectionScreen.jsx
import { useParams, Link } from 'react-router-dom';
import {
  Container,
} from 'react-bootstrap';
import DOMPurify from 'dompurify';
// import { toast } from 'react-toastify'; // resservira sûrement
import {
    useGetBooksCollectionDetailsQuery,
} from '../slices/booksCollectionsApiSlice';
import { useGetBooksByBooksCollectionQuery } from '../slices/booksApiSlice';
import Loader from '../components/Loader';
import Message from '../components/Message';
import Paginate from '../components/Paginate';
import Meta from '../components/Meta';
import BookCard from '../components/BookCard';
import { useState } from 'react';

const BooksCollectionScreen = () => {

  const { slug } = useParams();
  
  const {
    data: booksCollection
  } = useGetBooksCollectionDetailsQuery({slug});

  const {
    data: allBooks,
    isLoading,
    error,
  } = useGetBooksByBooksCollectionQuery(booksCollection?._id);

const params = useParams();

const pageNumber = parseInt(params.pageNumber) || 1;



return (
  <div>
    <Meta />
    {isLoading ? (
      <Loader />
    ) : error ? (
      <Message variant='danger'>
        {error?.allBooks?.message || error.error}
      </Message>
    ) : (
      <Container>
        <div className="h1-container">
          <h1>Collection {booksCollection?.name}</h1>
        </div>
        <div className='booksCollection-bio'>
          <div
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(booksCollection?.intention),
            }}
          />
        </div>
        <div className="book-row">
          {allBooks?.map((book) => (
            <div className='book-card' key={book._id}>
              <BookCard book={book} showPanier={true} />
            </div>
          ))}
        </div>



        {pageNumber === 1 ? (
          <div className="books-body">
            <div className="book-row-top">
              {allBooks?.books?.slice(0, 4).map((book) => (
                <div className='book-card' key={book._id}>
                  <BookCard book={book} showPanier={true}/>
                </div>
              ))}
            </div>
            <div className="book-row">
              {allBooks?.books?.slice(4).map((book) => (
                <div className='book-card' key={book._id}>
                  <BookCard book={book} showPanier={true} />
                </div>
              ))}
            </div>
          </div>
        ) : (
          <div className="book-row">
            {allBooks?.books?.map((book) => (
              <div className='book-card' key={book._id}>
                <BookCard book={book} showPanier={true} />
              </div>
            ))}
          </div>
        )}
        <Paginate pages={allBooks.pages} page={allBooks.page} basePath="/livres" />
      </Container>
    )}
  </div>
);
};






export default BooksCollectionScreen;
